window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.casinoUtrkeIHGRepo = function () {
    var get = function (restApiUrl, apiKey, turnirID, limit) {
        if (turnirID) {
            restApiUrl += '/CasinoUtrkeIHG?turnirID=' + turnirID;
        } else {
            restApiUrl += '/CasinoUtrkeIHG'
        }

        return fetch(restApiUrl, {
            credentials: repos.base.credentials,
            method: 'GET',
            credentials: 'include',
            headers: {
                "apiKey": apiKey
            },
        })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);
    };

    return {
        get: get
    }

}();